<div class="form-footer">
  <ng-content></ng-content>
</div>
